import cloneDeep from 'lodash/cloneDeep'
import { LOG_BATTLE, RESET_LOG } from '../../actions/game/battleLog.actions'

const initialState = []

const battleReducer = (state = initialState, action) => {
    const { payload } = action

    switch (action.type) {
        case LOG_BATTLE: {
            return [...cloneDeep(state), payload]
        }
        case RESET_LOG: {
            return initialState
        }

        default: {
            return state
        }
    }
}

export default battleReducer
